// extracted by mini-css-extract-plugin
export default {"shoppingMessageCard":"ShoppingMessageCard_shoppingMessageCard__f4fwZ"};